import {computed, observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";

export default class SomatorioHorasExtrasMOTBStore {
    @observable erro;
    @observable carregando;
    @observable dados;
    @observable cargos;

    constructor() {
        this.indicadorService = new IndicadorService();
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.indicadorService.findSomatorioHorasExtrasMOTB(filtro).then(response => {
            const produtosAgrupados = _.groupBy(response.data, (d) => d.produto);
            const produtos = Object.keys(produtosAgrupados);
            const cargosAgrupadas = _.groupBy(response.data, (d) => d.cargo);
            const cargos = Object.keys(cargosAgrupadas);

            let dados = [];
            _.forEach(produtos, (produto) => {
                let dado = { nome: produto };

                const produtosCargos = produtosAgrupados[produto];

                _.forEach(produtosCargos, (produtoCargo) => {
                    dado = { ...dado, [produtoCargo.cargo]: produtoCargo.quantidade };
                });

                dados = [ ...dados, dado ];
            });

            this.cargos = cargos;
            this.dados = dados;
            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }
}
